import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CardProps {
  variant?: 'default' | 'primary' | 'flat';
  className?: string;
  children: ReactNode;
  onClick?: () => void;
}

const styles: Record<NonNullable<CardProps['variant']>, string> = {
  default: 'bg-white border border-[#eeeeee] rounded-xl',
  primary: 'bg-gradient-to-br from-brand-400 to-brand-600 text-white rounded-xl',
  flat:    'bg-[#f5f5f5] rounded-xl',
};

export function Card({ variant = 'default', className, children, onClick }: CardProps) {
  return (
    <div
      className={cn(styles[variant], onClick && 'cursor-pointer', className)}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
